import { render, staticRenderFns } from "./cTemplateBuilderHierarchySuffix.vue?vue&type=template&id=51d94eaa&scoped=true"
import script from "./cTemplateBuilderHierarchySuffix.vue?vue&type=script&lang=js"
export * from "./cTemplateBuilderHierarchySuffix.vue?vue&type=script&lang=js"
import style0 from "./cTemplateBuilderHierarchySuffix.vue?vue&type=style&index=0&id=51d94eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d94eaa",
  null
  
)

export default component.exports